(function () {
  var COOKIE = 'ms_dismissed';

  function init() {
    if (document.cookie.indexOf(COOKIE + '=1') !== -1) return;

  var msEl = document.getElementById('market-suggestion');
    var FLAGS = msEl ? {
      GB: msEl.getAttribute('data-flag-gb'),
      DE: msEl.getAttribute('data-flag-de'),
      FR: msEl.getAttribute('data-flag-fr')
    } : {};

    var MARKETS = {
      GB: { domain: 'jewellerybox.co.uk', country: 'UK',     cta: 'Go to UK site' },
      DE: { domain: 'jewellerybox.de',    country: 'German', cta: 'Zum deutschen Shop' },
      FR: { domain: 'jewellerybox.fr',    country: 'French', cta: 'Aller sur le site FR' }
    };

var MESSAGES = {
      GB: function (cur) {
        var name = { GB: 'UK', DE: 'German', FR: 'French' }[cur] || '';
        return "You're on our " + name + " site. Would you like to view the same page on our UK site? Prices are shown in £ with UK shipping options.";
      },
      DE: function (cur) {
        var name = { GB: 'britischen', DE: 'deutschen', FR: 'französischen' }[cur] || '';
        return "Sie befinden sich auf unserer " + name + " Website. Möchten Sie diese Seite in unserem deutschen Shop ansehen? Preise in Euro mit deutschen Versandoptionen.";
      },
      FR: function (cur) {
        var name = { GB: 'britannique', DE: 'allemand', FR: 'français' }[cur] || '';
        return "Vous êtes sur notre site " + name + ". Souhaitez-vous voir cette même page sur notre site français ? Prix en euros avec options de livraison françaises.";
      }
    };
    function currentMarket() {
      var h = location.hostname;
      if (h.indexOf('jewellerybox.co.uk') !== -1) return 'GB';
      if (h.indexOf('jewellerybox.de') !== -1) return 'DE';
      if (h.indexOf('jewellerybox.fr') !== -1) return 'FR';
      return null;
    }

    function setCookie() {
      var d = new Date(); d.setTime(d.getTime() + 30 * 864e5);
      document.cookie = COOKIE + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }

    fetch('/browsing_context_suggestions.json', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!detected) return;

        var target = MARKETS[detected];
        if (!target) return;
        if (location.hostname.indexOf(target.domain) !== -1) return;

var el = document.getElementById('market-suggestion');
        if (!el) return;

        var current = currentMarket();
        if (!current) return;            // not on a recognised market domain — don't show

        el.querySelector('.ms-text').textContent = MESSAGES[detected](current);
        el.querySelector('.ms-cta-text').textContent = target.cta;

        var flag = el.querySelector('.ms-flag');
        flag.src = FLAGS[detected] || '';
        flag.alt = target.country + ' flag';

        var go = el.querySelector('.ms-go');
        go.href = location.protocol + '//' + target.domain + location.pathname + location.search;

        el.classList.add('ms-visible');

        el.querySelector('.ms-close').addEventListener('click', function () { el.classList.remove('ms-visible'); setCookie(); });
        el.querySelector('.ms-stay').addEventListener('click', function () { el.classList.remove('ms-visible'); setCookie(); });
        go.addEventListener('click', setCookie);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();